module.exports = __webpack_public_path__ + "img/warning-slip.57fa86c8.jpg";